import React, { useContext } from "react"
import { css } from "theme-ui"
import { QuizzContext } from "@bit/dweez.perso.quizz.contexts"

export default props => {
  const [state] = useContext(QuizzContext)
  return (
    <div
      className="wrapper-infos"
      css={css({
        marginTop: 5,
      })}
    >
      {!state.started && (
        <div
          className="bloc-infos"
          css={css({
            px: "1.5rem",
            py: ".5rem",
            borderRadius: "1rem",
            borderWidth: 1,
            borderColor: "primary",
            borderStyle: "solid",
            backgroundColor: "highlight",
            fontSize: 1,
          })}
        >
          <p>
            Aucune donnée ni information identifiante n’est collectée ou
            conservée. Approche « privacy by design » 100% garantie !
          </p>
        </div>
      )}
    </div>
  )
}
